import React from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import styled from 'styled-components';
import { v4 as uuid } from 'uuid';
import { ROLES } from '~/src/utils/constants';
import RolesDependent from '../RolesDependent';
import NavLink from './NavLink';

import pencilIcon from '../../../static/img/pencilIcon.svg';
import bulletIcon from '../../../static/img/bulletIcon.svg';
import kanbanIcon from '../../../static/img/kanbanIcon.svg';
import mathOperationsIcon from '../../../static/img/mathOperationsIcon.svg';
import { Colors } from '~/src/scss/common/style';

export default function DataOperationsNav(): React.ReactElement {
  const location = useLocation();
  let { id } = useParams();

  const navigationData = [
    {
      title: 'Logistics',
      subTitle: '',
      link: '/products/imports/upload',
      isSelected: location.pathname === '/products/imports/upload',
      isDisabled: false,
      icon: bulletIcon,
      roles: [
        ROLES.ADMIN,
        ROLES.SUPER_ADMIN,
        ROLES.WAREHOUSE,
        ROLES.WAREHOUSE_ADMIN,
        ROLES.OFFICE,
        ROLES.SALES,
        ROLES.DATABASE_ADMIN,
      ],
    },
    {
      title: 'Product sizes',
      subTitle: '',
      link: `/products/import-sizes/upload`,
      isSelected: location.pathname === `/products/import-sizes/upload`,
      isDisabled: !id,
      icon: pencilIcon,
      roles: [
        ROLES.ADMIN,
        ROLES.SUPER_ADMIN,
        ROLES.OFFICE,
        ROLES.SALES,
        ROLES.DATABASE_ADMIN,
        ROLES.WAREHOUSE,
        ROLES.WAREHOUSE_ADMIN,
      ],
    },
    {
      title: 'Supplier data',
      subTitle: '',
      link: `/products/import-supplier-data/upload`,
      isSelected: location.pathname === `/products/import-supplier-data/upload`,
      isDisabled: !id,
      icon: mathOperationsIcon,
      roles: [
        ROLES.ADMIN,
        ROLES.SUPER_ADMIN,
        ROLES.OFFICE,
        ROLES.SALES,
        ROLES.DATABASE_ADMIN,
        ROLES.WAREHOUSE,
        ROLES.WAREHOUSE_ADMIN,
      ],
    },
    {
      title: 'Analize packings',
      subTitle: '',
      link: `/products/products/packings`,
      isSelected: location.pathname === `/products/products/packings`,
      isDisabled: !id,
      icon: kanbanIcon,
      roles: [ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.SALES, ROLES.OFFICE, ROLES.DATABASE_ADMIN],
    },
    {
      title: 'Analize products',
      subTitle: '',
      link: `/products/analysis`,
      isSelected: location.pathname === `/products/analysis`,
      isDisabled: !id,
      icon: mathOperationsIcon,
      roles: [ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.OFFICE, ROLES.SALES],
    },
  ];

  return (
    <WrapperNav>
      <StyledSecondaryNavigation>
        {navigationData.map((item) => (
          <div key={uuid()}>
            <RolesDependent roles={item.roles}>
              <LinkStyle isSelected={item.isSelected} to={item.link}>
                {item.title}
              </LinkStyle>
            </RolesDependent>
          </div>
        ))}
      </StyledSecondaryNavigation>
      <StyledSecondaryNavigation>
        <LinkStyle isSelected="/inventory/import-export" to="/inventory/import-export">
          Import / export inventories
        </LinkStyle>
      </StyledSecondaryNavigation>
    </WrapperNav>
  );
}

const WrapperNav = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledSecondaryNavigation = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 10px 0;
  padding: 15px;
  font-size: 14px;
  border-radius: 10px;
  height: fit-content;
  background: ${Colors.darkBrown};
`;

const LinkStyle = styled(Link)`
  color: ${(props) => (props.isSelected ? Colors.newOrage : '#fff')};
  &:hover {
    color: red;
  }
`;
